import { makeStyles, createStyles, Theme, Box, Typography } from "@material-ui/core";
import { Button } from "~components";

export type ErrorStateProps = {
  title: string;
  buttonLabel: string;
  onClick: () => void;
};

export const ErrorState = ({ title, buttonLabel, onClick }: ErrorStateProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>{title}</Typography>
      <Button buttonType="secondary" onClick={onClick}>
        {buttonLabel}
      </Button>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
    title: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "normal",
      textAlign: "center",
      color: theme.palette.dark.main,
      marginBottom: theme.spacing(4),
    },
  }),
);
